module.exports = __webpack_public_path__ + "img/dea-formazione-ico-letteratura.cf34c37b.svg";